import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import rList from '../../models/rList';
import { rOyakKiraBilgileriUstBilgiKvtDetay } from '../../models/rOyakKiraBilgileriUstBilgiKvtDetay';

export default class OyakKiraBilgileriUstBilgiKvtDetayApi extends ApiBase<
  pList,
  rList<rOyakKiraBilgileriUstBilgiKvtDetay>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakKiraBilgileriUstBilgiKvtDetay',
      }),
      options
    );
  }
}
